<template>
    <el-select v-model="selectedCategory" :placeholder="placeholder" @change="handleChange">
        <el-option v-if="isSearchModel" label="すべて" :value="ALL" />
        <el-option v-for="item in categories" :key="item.category_id" :label="item.name" :value="item.category_id" />
    </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, computed } from 'vue';
import axios from 'axios';
import { ALL } from '@/config/constants';

export interface Category {
    category_id: string;
    name: string;
}

export default defineComponent({
    name: 'CategorySelect',
    props: {
        isSearch: {
            type: Boolean,
            default: false,
        },
        organizationId: {
            type: String,
            default: '',
        },
        modelValue: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '选择资财分类',
        },
    },
    emits: ['update:modelValue', 'change', 'category-name-change'],
    setup(props, { emit }) {
        const categories = ref<Category[]>([]);
        // 使用 computed 同步外部传入的 modelValue
        const selectedCategory = computed<string>({
            get() {
                return props.modelValue;
            },
            set(val: string) {
                emit('update:modelValue', val);
                emit('change', val);
            }
        });
        const isSearchModel = ref(props.isSearch);


        // 加载资财分类数据
        const fetchCategories = async () => {
            try {
                const response = await axios.get('/api/categories/all', {
                    params: {
                        organization_id: props.organizationId === ALL ? '' : props.organizationId,
                    },
                });
                categories.value = response.data.data || [];
            } catch (error) {
                console.error('获取资财分类列表失败:', error);
            }
        };


        const handleChange = (value: string) => {
            // 找到选中的分类对象
            const selectedCategoryObj = categories.value.find(
                category => category.category_id === value
            );

            // 如果找到了分类对象，发送名称
            if (selectedCategoryObj) {
                emit('category-name-change', selectedCategoryObj.name);
            }
        };

        // 初次加载，当 organizationId 有值时调用 fetchCategories
        onMounted(() => {
            // if (props.organizationId) {
            fetchCategories();
            // }
        });

        // 当 organizationId 变化时，重新加载分类数据，并检查当前选中值是否有效
        watch(
            () => props.organizationId,
            async (newOrgId, oldOrgId) => {
                if (newOrgId === oldOrgId) return;
                categories.value = [];
                if (newOrgId) {
                    await fetchCategories();
                    if (props.modelValue) {
                        const exists = categories.value.some(
                            category => category.category_id === props.modelValue
                        );
                        if (!exists) {
                            emit('update:modelValue', isSearchModel.value ? ALL : '');
                        }
                    } else {
                        // 如果不存在 modelValue，则保证为空
                        emit('update:modelValue', isSearchModel.value ? ALL : '');
                    }
                }
            }
        );

        watch(
            () => props.modelValue,
            (newVal) => {
                const selectedCategoryObj = categories.value.find(c => c.category_id === newVal);
                if (selectedCategoryObj) {
                    emit('category-name-change', selectedCategoryObj.name);
                }
            }
        );

        return {
            categories,
            selectedCategory,
            handleChange,
            isSearchModel,
            ALL
        };
    },
});
</script>